var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChocolate = function SvgChocolate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m438.828 20.771-162.94 282.221c-1.025 1.776-3.296 2.384-5.072 1.359l-26.329-15.201c-1.776-1.025-2.384-3.296-1.359-5.072l162.941-282.221c1.025-1.776 3.296-2.384 5.072-1.359l26.329 15.201c1.775 1.025 2.384 3.296 1.358 5.072z",
    fill: "#b79090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.83 127.462c-1.001-21.733-18.933-39.047-40.914-39.047-2.061 0-4.085.155-6.063.451-2.965.444-5.712-1.555-6.285-4.498-5.015-25.754-27.685-45.196-54.906-45.196-25.849 0-47.589 17.533-54.01 41.352-.721 2.676-3.282 4.398-6.036 4.092-2.04-.226-4.114-.343-6.215-.343-26.508 0-48.693 18.439-54.471 43.187l114.45 30z",
    fill: "#ebe1dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.48 365.534h-67.307c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h67.307c39.39 0 71.436-32.046 71.436-71.437v-53.568c0-24.152-19.649-43.801-43.801-43.801h-74.536c-4.267 0-7.726-3.459-7.726-7.726s3.459-7.726 7.726-7.726h74.536c32.673 0 59.254 26.581 59.254 59.254v53.568c0 47.91-38.979 86.888-86.889 86.888z",
    fill: "#b2e5fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.704 450.867h-11.194c-8.728 0-15.804-7.076-15.804-15.804v-63.859h-46.084v63.859c0 8.728-7.076 15.804-15.804 15.804h-11.194c-23.007 0-41.658 18.651-41.658 41.658v16.218c0 1.798 1.458 3.256 3.256 3.256h176.885c1.798 0 3.256-1.458 3.256-3.256v-16.218c-.001-23.007-18.652-41.658-41.659-41.658z",
    fill: "#b2e5fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.704 450.867h-11.194c-8.728 0-15.804-7.076-15.804-15.804v-63.859h-22.664v76.221c0 8.728 7.076 15.804 15.804 15.804h11.194c23.007 0 41.658 18.651 41.658 41.658v3.856c0 1.798-1.458 3.256-3.256 3.256h22.664c1.798 0 3.256-1.458 3.256-3.256v-16.218c0-23.007-18.651-41.658-41.658-41.658z",
    fill: "#91dafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.878 127.462h-230.429c-6.043 0-10.94 4.899-10.94 10.941v78.189l18.391 33.652 222.93 3.841 10.989-22.852v-92.83c-.001-6.042-4.898-10.941-10.941-10.941z",
    fill: "#b2e5fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.878 127.462h-30.905c6.043 0 10.941 4.899 10.941 10.941v105.557l30.905-12.727v-92.83c-.001-6.042-4.898-10.941-10.941-10.941z",
    fill: "#91dafa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.818 231.233v46.508c0 34.831-14.119 66.371-36.953 89.204-22.822 22.833-54.36 36.95-89.202 36.95-69.673 0-126.155-56.481-126.155-126.154v-61.149c24.485-11.963 54.624-12.602 80.853-8.523 52.937 8.238 117.041 38.74 171.457 23.164z",
    fill: "#b79090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.866 366.945c22.833-22.833 36.953-54.373 36.953-89.204v-46.508c-10.016 2.867-20.363 4.168-30.905 4.339v42.167c0 64.442-48.319 117.592-110.703 125.212 5.065.619 10.221.943 15.453.943 34.842.001 66.38-14.116 89.202-36.949z",
    fill: "#aa7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.19 446.357 111.579 64.42c4.36 2.517 9.934 1.023 12.451-3.336l101.187-175.262c2.517-4.36 1.023-9.934-3.336-12.451l-111.579-64.42c-4.36-2.517-9.934-1.023-12.451 3.336l-101.187 175.262c-2.517 4.36-1.023 9.934 3.336 12.451z",
    fill: "#aa7f7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.071 319.728-20.599-11.893c4.315 2.492 5.773 8.046 3.256 12.405l-101.187 175.262c-2.517 4.36-8.056 5.874-12.372 3.382l20.6 11.893c4.36 2.517 9.934 1.023 12.451-3.336l101.187-175.262c2.518-4.359 1.024-9.934-3.336-12.451z",
    fill: "#9d6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.334 394.66 7.727-13.382-56.992-32.905 32.904-56.992-13.382-7.726-32.905 56.992-56.992-32.904-7.726 13.382 56.992 32.904-29.041 50.301-56.992-32.904-7.726 13.382 56.992 32.904-32.905 56.992 13.383 7.726 32.904-56.992 56.992 32.905 7.726-13.383-56.992-32.904 29.041-50.3z",
    fill: "#9d6c6c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#8c5e5e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m154.364 433.743h15.453v23.878h-15.453z",
    transform: "matrix(.5 -.866 .866 .5 -304.927 363.215)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.132 370.06h15.453v23.878h-15.453z",
    transform: "matrix(.5 -.866 .866 .5 -231.392 363.216)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChocolate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chocolate.f377b3b0.svg";
export { ForwardRef as ReactComponent };